import React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var ONOTYImage = _ref => {
  var {
    image
  } = _ref;
  var id = Math.floor(Math.random() * 1000);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("svg", {
      className: "p-4 lg:p-8 h-auto",
      width: "100%",
      height: "100%",
      viewBox: "0 0 352 441",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      preserveAspectRatio: "xMidYMin meet",
      children: [/*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M87 0H0V87H11.0925V11.0925H87V0Z",
        fill: "url(#" + id + "paint0)"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M265 441H352V354H340.907V429.907H265V441Z",
        fill: "url(#" + id + "paint1)"
      }), /*#__PURE__*/_jsx("rect", {
        x: "34",
        y: "33",
        width: "283",
        height: "375",
        fill: "url(#" + id + "pattern0)"
      }), /*#__PURE__*/_jsxs("defs", {
        children: [/*#__PURE__*/_jsxs("linearGradient", {
          id: id + "paint0",
          x1: "43.5",
          y1: "0",
          x2: "43.5",
          y2: "87",
          gradientUnits: "userSpaceOnUse",
          children: [/*#__PURE__*/_jsx("stop", {
            stopColor: "#0099DA"
          }), /*#__PURE__*/_jsx("stop", {
            offset: "1",
            stopColor: "#42B479"
          })]
        }), /*#__PURE__*/_jsxs("linearGradient", {
          id: id + "paint1",
          x1: "308.5",
          y1: "441",
          x2: "308.5",
          y2: "354",
          gradientUnits: "userSpaceOnUse",
          children: [/*#__PURE__*/_jsx("stop", {
            stopColor: "#42B479"
          }), /*#__PURE__*/_jsx("stop", {
            offset: "1",
            stopColor: "#0099DA"
          })]
        }), /*#__PURE__*/_jsx("pattern", {
          id: id + "pattern0",
          patternContentUnits: "objectBoundingBox",
          viewBox: "0 0 1 1",
          preserveAspectRatio: "xMidYMid slice",
          width: "100%",
          height: "100%",
          children: /*#__PURE__*/_jsx("image", {
            width: "0.9",
            height: "1",
            href: image == null ? void 0 : image.filename,
            preserveAspectRatio: "xMidYMid slice"
          })
        })]
      })]
    }), image != null && image.name ? /*#__PURE__*/_jsx("p", {
      className: "text-sm italic float-right",
      children: image.name
    }) : null]
  });
};
//# sourceMappingURL=onoty_image.js.map